// Shared styling for ShareButton component across all pages
export const rainbowShareButtonStyles = {
  px: 6,
  py: 3,
  fontSize: '1.2rem',
  fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
  fontWeight: 700,
  borderRadius: 3,
  background: 'linear-gradient(45deg, #ff6b6b 0%, #ffa726 16%, #ffeb3b 33%, #66bb6a 50%, #42a5f5 66%, #ab47bc 83%, #ff6b6b 100%)',
  backgroundSize: '300% 300%',
  animation: 'rainbow 3s ease infinite',
  color: '#ffffff',
  textShadow: '0 1px 2px rgba(0,0,0,0.7)',
  boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
  transition: 'all 0.3s ease-in-out',
  '@keyframes rainbow': {
    '0%': { backgroundPosition: '0% 50%' },
    '50%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 16px rgba(255, 107, 107, 0.5)',
  },
  '&:active': {
    transform: 'translateY(0px)',
  },
};

// Compact version for smaller contexts
export const compactRainbowShareButtonStyles = {
  ...rainbowShareButtonStyles,
  px: 4,
  py: 2,
  fontSize: '1rem',
};